import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerInitiateMatchPaymentApiCallSuccess } from 'redux/actions';
import { TRIGGER_INITIATE_MATCH_PAYMENT_API } from 'redux/actionTypes';
import { apiCall } from 'services';
import { nativeHandler } from 'utils';

function* triggerInitiateMatchPaymentApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE,
		url: API_CONSTANT.URL.SCRATCH_CARD.T20.INITIATE_PAYMENT,
		method: 'POST',
		data,
		options: {
			defaultLoader: !stopLoader,
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		callback && callback(apiData);
		yield put(triggerInitiateMatchPaymentApiCallSuccess(apiData));
		localStorage.setItem('orderId', apiData?.orderId);
		nativeHandler.openDeepLinkWithCallback(apiData?.paymentDeepLink, () => {
			nativeHandler.removeLoader();
			callback(apiData?.orderId);
		});
	}
}

export default function* triggerInitiateMatchPaymentApiCallSaga() {
	yield takeEvery(TRIGGER_INITIATE_MATCH_PAYMENT_API, triggerInitiateMatchPaymentApiCall);
}
